// extracted by mini-css-extract-plugin
export default {"txt":"Service_txt_oH8Hu"};